<template>
  <div class="list-box">
    <div style="display: flex; align-items: center; margin-bottom: 10px">
      <div style="flex: 1; font-size: 13px; color: #ffa500">
        <text>注：1、选择开户行省份；</text>
        <li style="text-indent: 2em">
          2、找到列表中要申请的银行信息，单击选中后(该条记录背景色变成<text
            style="color: #1e90ff"
            >浅蓝色</text
          >后即为选中状态)即可提交；
        </li>
      </div>
      <text style="color: #a2a2a2">开户行省份：</text>
      <el-select
        v-model="state.khyhsf"
        placeholder="开户行省份"
        style="width: 200px; margin-right: 10px"
        :clearable="false"
      >
        <el-option
          v-for="item in state.openbank_province_data"
          :key="item"
          :label="item.name"
          :value="item.name"
        >
        </el-option>
      </el-select>
      <el-button type="primary" @click="onSubmit">提交申请</el-button>
      <el-button type="info" @click="onClose">取消</el-button>
    </div>
    <ul class="list-table">
      <el-table
        ref="tableDom"
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
        highlight-current-row
        @current-change="onRowClick"
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column
          prop="yhmc"
          label="银行名称"
          show-overflow-tooltip
          :formatter="
            (row, column, cellValue) =>
              $tab_Highlinght(cellValue, state.params.keywords)
          "
        />
        <el-table-column
          prop="yhwdmc"
          label="银行营业网点名称"
          show-overflow-tooltip
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          prop="yhzh"
          label="银行账号"
          show-overflow-tooltip
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          prop="yhzhmc"
          label="银行账户名称"
          show-overflow-tooltip
          :formatter="$tab_TextFormat"
        />
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
  </div>
  <transition name="el-zoom-in-center">
    <c_popup
      v-if="state.showInfo"
      :title="(state.selectId ? '修改' : '添加') + '自营扣缴义务人'"
      @close="state.showInfo = false"
    >
      <c_WithholdingAgentInfo
        @close="
          state.showInfo = false;
          onLoad();
        "
        :id="state.selectId"
      ></c_WithholdingAgentInfo>
    </c_popup>
  </transition>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  ptscommission_getyhzh,
  ptscommission_confirm,
} from "@/http/ptscommission";
import { ElMessage, ElMessageBox } from "element-plus";
import { openbank_province_select } from "@/http/dictionary";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    sort_value: "desc",
  };
}
export default {
  props: {
    id: Number,
    withholding_agent_id: Number,
  },
  setup(props, { emit }) {
    const tableDom = ref(null);
    const state = reactive(new InitFormData());
    onMounted(() => {
      state.params.withholding_agent_id = props.withholding_agent_id;
      onLoadBankProvince();
      onLoad();
    });

    const onLoadBankProvince = () => {
      openbank_province_select().then((res) => {
        if (res.status == 200) state.openbank_province_data = res.data.data;
      });
    };

    const onLoad = () => {
      delete state.tableData;
      ptscommission_getyhzh(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    const onClose = () => {
      emit("Close");
    };

    const onRowClick = (row) => {
      state.selectRow = row;
    };

    const onSubmit = () => {
      if (!state.selectRow) {
        ElMessage({
          type: "warning",
          message: "请选择银行账户",
          grouping: true,
        });
        return false;
      }

      ElMessageBox.confirm(`您确定提交核对申请吗？`, "更新确认", {
        dangerouslyUseHTMLString: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const data = {
          id: props.id,
          yhzhlb_id:state.selectRow?.id,
          khyhsf: state.khyhsf,
        };

        ptscommission_confirm(data).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            emit("Comfirm");
          }
        });
      });
    };

    return {
      state,
      onLoad,
      onSortChange,
      onReset,
      props,
      tableDom,
      onClose,
      onSubmit,
      onRowClick,
    };
  },
};
</script>
<style scoped></style>
